import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 9H9V16H7V9H0V7H7V0H9V7H16V9Z", fill: "#193D6D" }));
export { SvgPlus as ReactComponent };
